module.exports = __webpack_public_path__ + "static/media/dring.3c180d25.mp3";